"use client";

import classNames from "classnames";
import Image from "next/image";
import { useMemo } from "react";
import { Inter } from "next/font/google";
import { Fragment } from "react";
import { FormatAmount } from "@/utils";
import { usePathname } from "next/navigation";
const inter = Inter({ subsets: ["latin"] });

export const MIN_SOCIAL_PROOF = 128;
export const MAX_SOCIAL_PROOF = 249;

const hashString = (str) => {
	return str.split("").reduce((acc, char) => {
		return acc + char.charCodeAt(0);
	}, 0);
};

const randomAvatars = (count, hashValue = "foo") => {
	const hash = hashString(hashValue);

	return new Array(count).fill(null).map((_, index) => {
		const avatarIndex = ((hash + index) % 45) + 1;
		return `/assets/avatars/Avatar user-${avatarIndex}.png`;
	});
};

export const SocialProofAvatars = ({
	avatarsBorderColor,
	count = 0,
	totalCount = 0,
}) => {
	const pathname = usePathname();
	const avatars = useMemo(() => {
		return randomAvatars(count, pathname);
	}, [count, pathname]);

	return (
		<div
			className="relative h-5"
			style={{
				width: avatars.length > 0 && `${(avatars.length - 1) * 12 + 20}px`,
			}}>
			{avatars.map((avatar, index) => {
				if (avatar) {
					return (
						<Image
							key={index}
							src={avatar}
							alt="Gluten Free Users"
							width={20}
							height={20}
							style={{ objectFit: "contain", left: `${index * 12}px` }}
							className={classNames({
								"ring-white": avatarsBorderColor === "white",
								"ring-black": !avatarsBorderColor || avatarsBorderColor === "black",
								"ring-[#212b37]": avatarsBorderColor === "#212b37",
								"size-5 absolute top-0 ring-1 rounded-full": true,
								"bg-gray-400": true,
							})}
						/>
					);
				}

				return (
					<Fragment key={index}>
						<div
							style={{ left: `${index * 12}px` }}
							className="animate-pulse size-5 absolute top-0 ring-1 z-10 ring-white rounded-full bg-gray-400 border-box"
						/>
						<div
							style={{ left: `${index * 12}px` }}
							className="size-5 absolute top-0 rounded-full bg-gray-400 border-box"
						/>
					</Fragment>
				);
			})}
			{totalCount > 0 ? (
				<>
					<div
						style={{ left: `${avatars.length * 12}px` }}
						className={classNames(inter.className, {
							"animate-pulse": true,
							"border border-white border-box": avatarsBorderColor === "white",
							"bg-gradient-dark-porange w-10 h-5 absolute top-0 z-10 rounded-full": true,
							"text-white text-xs flex items-center justify-center": true,
						})}>
						<span id="social-proof-avatars-count">
							{FormatAmount(totalCount)}+
						</span>
					</div>
					<div
						style={{ left: `${avatars.length * 12}px` }}
						className={classNames(inter.className, {
							"border border-white border-box": avatarsBorderColor === "white",
							"bg-white w-10 h-5 absolute top-0 rounded-full": true,
							"text-white text-xs flex items-center justify-center": true,
						})}
					/>
				</>
			) : null}
		</div>
	);
};
